import { NotificationManager } from "react-notifications";

const uri = process.env.ADMIN_REST_API;
const EXCEL_EXTENSION = ".xlsx";

export function getTemplateExcelFile() {
  return fetch(`${uri}/UserBulk/GetTemplate`, {
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.blob();
    })
    .then((data) => {
      let a = document.createElement("a");
      a.href = window.URL.createObjectURL(data);
      a.download = "users-template" + EXCEL_EXTENSION;
      a.click();
    });
}

export function uploadExcelFile(fileInput) {
  let formdata = new FormData();
  formdata.append("excelDocument", fileInput.file.file);
  let requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow",
    headers: {},
  };

  return fetch(`${uri}/UserBulk/ImportDocument`, requestOptions)
    .then((response) => response.text())
    .catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
}
